export enum PaymentMethodType {
  None = '',
  Cash = 'Cash',
  DebitOrder = 'Debit Order',
  DebitOrderCurrent = 'Debit Order Current',
  DebitOrderSavings = 'Debit Order Savings',
  DebitOrderTransmission = 'Debit Order Transmission',
  CreditCard = 'Credit Card',
  DebitOrderCRCard = 'Debit Order CR Card',
}

export const debitPaymentMethods = [
  PaymentMethodType.DebitOrderCurrent,
  PaymentMethodType.DebitOrderSavings,
  PaymentMethodType.DebitOrderTransmission,
  PaymentMethodType.DebitOrderCRCard,
];